var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.629C8.6134 11.629 8.3 11.9424 8.3 12.329C8.3 12.7156 8.6134 13.029 9 13.029V11.629ZM19 18L18.3626 18.2892C18.4987 18.5894 18.8258 18.7538 19.148 18.6842C19.4701 18.6145 19.7 18.3296 19.7 18H19ZM9 5.702H8.3C8.3 6.07071 8.58601 6.37621 8.95393 6.40048L9 5.702ZM9 1H9.7C9.7 0.716876 9.52945 0.461631 9.26788 0.353284C9.00631 0.244938 8.70522 0.304827 8.50503 0.505025L9 1ZM1 9L0.505025 8.50503L0.0100505 9L0.505025 9.49498L1 9ZM9 17L8.50503 17.495C8.70522 17.6952 9.00631 17.7551 9.26788 17.6467C9.52945 17.5384 9.7 17.2831 9.7 17H9ZM9.7 12.333C9.7 11.9464 9.3866 11.633 9 11.633C8.6134 11.633 8.3 11.9464 8.3 12.333H9.7ZM9 13.029C13.3752 13.029 16.9964 15.2785 18.3626 18.2892L19.6374 17.7108C18.0016 14.1055 13.8128 11.629 9 11.629V13.029ZM19.7 18V16.993H18.3V18H19.7ZM19.7 16.993C19.7 10.6407 15.0245 5.39786 9.04607 5.00352L8.95393 6.40048C14.1335 6.74214 18.3 11.3133 18.3 16.993H19.7ZM9.7 5.702V1H8.3V5.702H9.7ZM8.50503 0.505025L0.505025 8.50503L1.49497 9.49498L9.49498 1.49497L8.50503 0.505025ZM0.505025 9.49498L8.50503 17.495L9.49498 16.505L1.49497 8.50503L0.505025 9.49498ZM9.7 17V12.333H8.3V17H9.7Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.17ff4ab36e31d7406ff1780ad96a6fa4.svg";
export { ForwardRef as ReactComponent };